/**
 * Shared Calculator Tools for Blogposts
 * This file contains calculator functions for various tools used across blog posts
 */

// Common utility functions
const calculatorTools = {
  // Format dimensions from inches to feet and inches
  formatDimension: function(inches) {
    if (!inches) return '0';
    const feet = Math.floor(inches / 12);
    const remainingInches = Math.round(inches % 12);
    if (feet === 0) return `${remainingInches}"`;
    return remainingInches === 0 ? `${feet}'` : `${feet}' ${remainingInches}"`;
  },
  
  // Create a result row HTML
  createResultRow: function(label, value) {
    return `
      <div class="result-row">
        <span class="result-label">${label}:</span>
        <span class="result-value">${value}</span>
      </div>
    `;
  }
};

/************************
 * CEILING FAN CALCULATOR
 ************************/
const ceilingFanCalculator = {
  init: function() {
    // Add click handler to the calculate button
    const calculateBtn = document.getElementById('fan-calculate-btn');
    if (calculateBtn) {
      calculateBtn.addEventListener('click', this.calculateFanSize);
    }
  },
  
  calculateFanSize: function() {
    // Get input values
    const length = parseFloat(document.getElementById('room-length').value);
    const width = parseFloat(document.getElementById('room-width').value);
    const ceilingHeight = document.getElementById('ceiling-height').value;
    const roomType = document.getElementById('room-type').value;
    
    // Validate inputs
    if (isNaN(length) || isNaN(width) || length <= 0 || width <= 0) {
      alert('Please enter valid room dimensions');
      return;
    }
    
    // Calculate square footage
    const squareFootage = length * width;
    
    // Determine fan size based on square footage
    let fanSize = "";
    let mountType = "";
    let additionalTip = "";
    
    // Fan size logic
    if (squareFootage <= 75) {
      fanSize = "29-36 inches";
    } else if (squareFootage <= 144) {
      fanSize = "36-42 inches";
    } else if (squareFootage <= 225) {
      fanSize = "44-50 inches";
    } else if (squareFootage <= 400) {
      fanSize = "52-60 inches";
    } else {
      fanSize = "60+ inches or consider multiple fans";
      additionalTip = "For rooms this large, consider installing multiple fans for better air circulation.";
    }
    
    // Mount type based on ceiling height
    if (ceilingHeight === "under8") {
      mountType = "Hugger/Flush Mount";
      additionalTip += " Low-profile or hugger fan recommended for your ceiling height.";
    } else if (ceilingHeight === "8to9") {
      mountType = "Standard Mount";
    } else {
      mountType = "Extended Downrod Mount";
      additionalTip += " Use a longer downrod to position the fan 8-9 feet from the floor for optimal airflow.";
    }
    
    // Room-specific recommendations
    if (roomType === "bedroom") {
      additionalTip += " For bedrooms, consider fans with quiet operation and dimming light features.";
    } else if (roomType === "living") {
      additionalTip += " Position the fan over the main seating area for best comfort.";
    } else if (roomType === "kitchen") {
      additionalTip += " Kitchen fans should have easy-to-clean blades as they will collect grease over time.";
    } else if (roomType === "outdoor") {
      additionalTip += " Make sure to select a fan rated for damp or wet locations for outdoor use.";
    }
    
    // Display results
document.getElementById('square-footage').textContent = `Room Size: ${squareFootage} square feet`;
    document.getElementById('fan-size').textContent = `Recommended Fan Size: ${fanSize}`;
    document.getElementById('mount-type').textContent = `Recommended Mount Type: ${mountType}`;
    document.getElementById('additional-tip').textContent = additionalTip.trim();
    document.getElementById('result-box').style.display = 'block';
  }
};

/************************
 * DINING TABLE CALCULATOR
 ************************/
const diningTableCalculator = {
  selectedShape: 'rectangular',
  
  init: function() {
    // Get all shape buttons
    const shapeButtons = document.querySelectorAll('.shape-button');
    const calculateBtn = document.getElementById('table-calculate-btn');
    
    if (shapeButtons.length > 0 && calculateBtn) {
      // Add click event to shape buttons
      shapeButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Remove active class from all buttons
          shapeButtons.forEach(btn => btn.classList.remove('active'));
          
          // Add active class to clicked button
          this.classList.add('active');
          
          // Update selected shape
          diningTableCalculator.selectedShape = this.getAttribute('data-shape');
        });
      });
      
      // Set initial active shape
      shapeButtons[0].classList.add('active');
      
      // Calculate button click handler
      calculateBtn.addEventListener('click', this.calculateTableSize);
    }
  },
  
  calculateTableSize: function() {
    // Get input values
    const roomWidth = parseFloat(document.getElementById('table-room-width').value);
    const roomLength = parseFloat(document.getElementById('table-room-length').value);
    const peopleCount = parseInt(document.getElementById('people-count').value);
    
    // Convert room dimensions to inches
    const roomWidthInches = roomWidth * 12;
    const roomLengthInches = roomLength * 12;
    
    // Constants
    const minSpacePerPerson = 24; // inches width per person
    const minClearance = 36; // inches around table
    
    // Max available space after clearance
    const maxWidth = roomWidthInches - (minClearance * 2);
    const maxLength = roomLengthInches - (minClearance * 2);
    
    // Initialize result object
    let result = {
      width: 0,
      length: 0,
      diameter: 0,
      idealCapacity: 0,
      maxCapacity: 0,
      isViable: true,
      message: ''
    };
    
    // Check if room is too small
    if (maxWidth < 30 || maxLength < 30) {
      result.isViable = false;
      result.message = 'Room is too small for a standard dining table with proper clearance.';
    } else {
      // Calculate based on shape
      switch(diningTableCalculator.selectedShape) {
        case 'rectangular':
          diningTableCalculator.calculateRectangular(result, maxWidth, maxLength, peopleCount, minSpacePerPerson);
          break;
        case 'round':
          diningTableCalculator.calculateRound(result, maxWidth, maxLength, peopleCount, minSpacePerPerson);
          break;
        case 'square':
          diningTableCalculator.calculateSquare(result, maxWidth, maxLength, peopleCount, minSpacePerPerson);
          break;
        case 'oval':
          diningTableCalculator.calculateOval(result, maxWidth, maxLength, peopleCount, minSpacePerPerson);
          break;
      }
    }
    
    // Display results
    diningTableCalculator.displayResults(result, peopleCount, roomWidthInches, roomLengthInches);
  },
  
  calculateRectangular: function(result, maxWidth, maxLength, peopleCount, minSpacePerPerson) {
    const minTableWidth = Math.min(maxWidth, 42); // Standard width 36-42"
    const requiredLength = Math.ceil(peopleCount / 2) * minSpacePerPerson;
    
    result.width = minTableWidth;
    result.length = Math.min(maxLength, requiredLength);
    result.idealCapacity = Math.floor(result.length / minSpacePerPerson) * 2;
    result.maxCapacity = Math.floor(result.length / 20) * 2; // Tighter fit
    
    if (result.idealCapacity < peopleCount) {
      result.message = `This room comfortably seats ${result.idealCapacity} people, which is less than your desired ${peopleCount}.`;
    }
  },
  
  calculateRound: function(result, maxWidth, maxLength, peopleCount, minSpacePerPerson) {
    const maxDiameter = Math.min(maxWidth, maxLength);
    const requiredCircumference = peopleCount * minSpacePerPerson;
    const requiredDiameter = requiredCircumference / Math.PI;
    
    result.diameter = Math.min(maxDiameter, requiredDiameter);
    result.idealCapacity = Math.floor((Math.PI * result.diameter) / minSpacePerPerson);
    result.maxCapacity = Math.floor((Math.PI * result.diameter) / 20);
    
    if (result.idealCapacity < peopleCount) {
      result.message = `A round table in this room comfortably seats ${result.idealCapacity} people.`;
    }
  },
  
  calculateSquare: function(result, maxWidth, maxLength, peopleCount, minSpacePerPerson) {
    const maxSide = Math.min(maxWidth, maxLength);
    const idealSide = Math.min(maxSide, peopleCount * minSpacePerPerson / 4);
    
    result.width = result.length = idealSide;
    result.idealCapacity = Math.floor(idealSide / minSpacePerPerson) * 4;
    result.maxCapacity = Math.floor(idealSide / 20) * 4;
    
    if (result.idealCapacity < peopleCount) {
      result.message = `A square table in this room comfortably seats ${result.idealCapacity} people.`;
    }
  },
  
  calculateOval: function(result, maxWidth, maxLength, peopleCount, minSpacePerPerson) {
    const ovalWidth = Math.min(maxWidth, 42);
    const ovalLength = Math.min(maxLength, (peopleCount * minSpacePerPerson) / 1.8);
    
    result.width = ovalWidth;
    result.length = ovalLength;
    result.idealCapacity = Math.floor((2 * ovalLength + Math.PI * ovalWidth) / minSpacePerPerson);
    result.maxCapacity = Math.floor((2 * ovalLength + Math.PI * ovalWidth) / 20);
    
    if (result.idealCapacity < peopleCount) {
      result.message = `An oval table in this room comfortably seats ${result.idealCapacity} people.`;
    }
  },
  
  displayResults: function(result, peopleCount, roomWidthInches, roomLengthInches) {
    const dimensionsContainer = document.getElementById('table-dimensions-container');
    const tableShape = document.getElementById('table-shape');
    const warningElement = document.getElementById('table-warning');
    const resultsContainer = document.getElementById('table-results');
    
    // Clear previous results
    dimensionsContainer.innerHTML = '';
    
    if (!result.isViable) {
      // Display error message
      warningElement.textContent = result.message;
      warningElement.style.display = 'block';
      resultsContainer.style.display = 'block';
      tableShape.style.display = 'none';
      return;
    }
    
    // Create dimensions HTML
    let dimensionsHTML = '';
    
    if (diningTableCalculator.selectedShape === 'round') {
      dimensionsHTML += calculatorTools.createResultRow('Diameter', calculatorTools.formatDimension(result.diameter));
    } else {
      dimensionsHTML += calculatorTools.createResultRow('Width', calculatorTools.formatDimension(result.width));
      dimensionsHTML += calculatorTools.createResultRow('Length', calculatorTools.formatDimension(result.length));
    }
    
    dimensionsHTML += calculatorTools.createResultRow('Ideal Capacity', `${result.idealCapacity} people`);
    dimensionsHTML += calculatorTools.createResultRow('Maximum Capacity', `${result.maxCapacity} people`);
    
    // Add to container
    dimensionsContainer.innerHTML = dimensionsHTML;
    
    // Show warning if needed
    if (result.message) {
      warningElement.textContent = result.message;
      warningElement.style.display = 'block';
    } else {
      warningElement.style.display = 'none';
    }
    
    // Calculate table visual dimensions (as percentage of container)
    let visualWidth, visualHeight, borderRadius;
    
    switch(diningTableCalculator.selectedShape) {
      case 'round':
        visualWidth = visualHeight = (result.diameter / Math.max(roomWidthInches, roomLengthInches) * 80);
        borderRadius = '50%';
        break;
      case 'square':
        visualWidth = visualHeight = (result.width / Math.max(roomWidthInches, roomLengthInches) * 80);
        borderRadius = '0';
        break;
      case 'oval':
        visualWidth = (result.width / roomWidthInches * 80);
        visualHeight = (result.length / roomLengthInches * 80);
        borderRadius = '40%';
        break;
      case 'rectangular':
        visualWidth = (result.width / roomWidthInches * 80);
        visualHeight = (result.length / roomLengthInches * 80);
        borderRadius = '0';
        break;
    }
    
    // Update table visual
    tableShape.style.width = `${visualWidth}%`;
    tableShape.style.height = `${visualHeight}%`;
    tableShape.style.borderRadius = borderRadius;
    tableShape.style.borderColor = result.idealCapacity >= parseInt(peopleCount) 
      ? '#1F1A5E' : '#d69e2e';
    tableShape.style.backgroundColor = result.idealCapacity >= parseInt(peopleCount)
      ? 'rgba(31, 26, 94, 0.2)' : 'rgba(214, 158, 46, 0.2)';
    
    // Add text to table visual
    tableShape.textContent = diningTableCalculator.selectedShape === 'round'
      ? `${calculatorTools.formatDimension(result.diameter)} diameter`
      : `${calculatorTools.formatDimension(result.width)} × ${calculatorTools.formatDimension(result.length)}`;
    
    tableShape.style.display = 'flex';
    resultsContainer.style.display = 'block';
  }
};

// Initialize all calculators when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Check which calculator is on the page and initialize it
  if (document.getElementById('fan-calculate-btn')) {
    ceilingFanCalculator.init();
  }
  
  if (document.getElementById('table-calculate-btn')) {
    diningTableCalculator.init();
  }
});